export default __webpack_public_path__ + "static/media/gammeok.b57cf9e2.jpeg";